// extracted by mini-css-extract-plugin
module.exports = {"root":"characters_root__VJb5s","item":"characters_item__4_ZwY","character":"characters_character__td1vT"};